import { Text } from '@chakra-ui/react';
import TextSection from '@components/articles/SeoTextSection';
import { partBDeductible } from '@components/crm/utils/irmaa';
import { fontSize } from '@constants/styles';
import CoverageOutline from './CoverageOutline';
import Plans from './Plans';

const coverage = [
  { covered: true, name: 'Part A Coinsurance' },
  { covered: true, name: 'Part A Hospice Care Coinsurance + Copay' },
  { covered: true, name: 'Part A Deductible' },
  { covered: true, name: 'Blood (3 Pints)' },
  { covered: true, name: 'Part B Coinsurance + Copay' },
  { covered: true, name: 'Part B Excess Charge' },
  { covered: false, name: 'Part B Deductible' },
];

const PlanG = ({ renderCta, name, carriers, averagePremium }) => (
  <>
    <TextSection title={`What You Need to Know about Plan G in ${name}:`}>
      <Text fontSize={fontSize.p}>
        Again, the benefits of Medicare Supplement Plans are defined by the government, which means the coverage is the
        same for each plan letter no matter the cost. We recommend you{' '}
        <b>go with the cheapest carrier offering Plan G (which we’ve included below)</b>. All you need to worry about
        paying is your monthly premium and the yearly Part B Deductible of ${partBDeductible} for any Medicare approved
        medical services.
      </Text>
      <Text fontSize={fontSize.p}>
        The average monthly premium in {name} for Plan G is <b>${averagePremium.toFixed(2)}</b>.
      </Text>
      <Text fontSize={fontSize.p}>
        If you want the most comprehensive coverage, Plan G is for you. Take a look at what that entails below:
      </Text>
      <CoverageOutline coverage={coverage} />
      <Text fontSize={fontSize.p}>
        Plan G also offers 80% coverage on foreign travel exchange, which is the highest on Medicare. Since you’ll get
        this same coverage no matter the monthly premium, we’ve compiled the average cost of Plan G across {name}.
      </Text>
    </TextSection>
    <TextSection title={`Top 10 Cheapest Plan G Options in ${name}:`}>
      <Plans plans={carriers} />
      <Text fontSize={fontSize.p}>
        Premiums do vary by zip code, so contact us below to hear the local premiums you can actually enroll in.
      </Text>
      {renderCta()}
    </TextSection>
  </>
);

export default PlanG;
